module.exports = __webpack_public_path__ + "img/img-i5gam-ct-list6.bb7f30de.png";